import { render, staticRenderFns } from "./productShare.vue?vue&type=template&id=76332330&scoped=true"
import script from "./productShare.vue?vue&type=script&lang=js"
export * from "./productShare.vue?vue&type=script&lang=js"
import style0 from "./productShare.vue?vue&type=style&index=0&id=76332330&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76332330",
  null
  
)

export default component.exports